var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "image-upload-container" }, [
    _c(
      "div",
      { staticClass: "hint" },
      [
        _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
        _vm.hint
          ? _c("CommonHint", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "hint",
                    fn: function() {
                      return [_vm._t("hint")]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      {
        class: `image-uploader ${_vm.isBig ? "big" : ""}`,
        on: {
          dragover: function($event) {
            $event.preventDefault()
          },
          drop: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("input", {
          ref: "imageInput",
          staticClass: "input-image",
          attrs: { type: "file", accept: _vm.acceptList },
          on: { change: _vm.uploadImageWithClick }
        }),
        _vm.previewUrl?.trim?.() === ""
          ? _c(
              "label",
              {
                staticClass: "uploader-section",
                on: {
                  click: function($event) {
                    return _vm.$refs.imageInput.click()
                  },
                  drop: _vm.uploadImageWithDrop
                }
              },
              [
                _c("span", { staticClass: "uploader-label" }, [
                  _c("img", {
                    staticClass: "uploader-image",
                    attrs: {
                      src: require("@/drc/assets/icons/image-upload-black.svg"),
                      alt: "image"
                    }
                  }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.uploadText || _vm.$t("projectFroms.uploadFile")
                      )
                    )
                  ])
                ])
              ]
            )
          : _vm._e(),
        _vm.previewUrl?.trim?.() !== ""
          ? _c(
              "span",
              {
                class: [
                  "preview",
                  "large",
                  { "error-border": _vm.formData[_vm.field].errors.length > 0 }
                ]
              },
              [
                _c("img", {
                  staticClass: "close",
                  attrs: {
                    src: require("@/drc/assets/icons/x-with-cicle.svg"),
                    width: "18",
                    height: "18",
                    alt: "close"
                  },
                  on: { click: _vm.removeImage }
                }),
                _c("img", {
                  ref: "imagePreview",
                  staticClass: "preview-image",
                  attrs: { src: _vm.previewUrl, alt: "logo" }
                })
              ]
            )
          : _vm._e(),
        _vm.formData[_vm.field].errors.length > 0
          ? _c(
              "div",
              { staticClass: "image-upload-error" },
              _vm._l(_vm.formData[_vm.field].errors, function(error, index) {
                return _c("span", { key: index }, [
                  _vm._v(" " + _vm._s(_vm.$t(`${error}`) + ".") + " ")
                ])
              }),
              0
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }